import React from 'react';
import PropTypes from 'prop-types';
import { GridList, GridListTile, Checkbox } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { colors } from 'kangarootime-ui';
import GalleryPhoto from './GalleryPhoto';

const GalleryGrid = ({ photos, onPhotoClick, handlePhotoDeleteRequest, selectPhoto, isPhotoSelected, ...props }) => {
  const getGridListCols = () => {
    if (isWidthUp('xl', props.width)) {
      return 6;
    }

    if (isWidthUp('lg', props.width)) {
      return 5;
    }

    if (isWidthUp('md', props.width)) {
      return 3;
    }

    return 2;
  };

  return (
    <GridList cellHeight={160} cols={getGridListCols()}>
      {photos.map((photo, index) => (
        <GridListTile key={index} cols={1} onClick={(event) => {
          // checkbox was selected and the lightbox should not be opened
          if (event.target.type && event.target.type === 'checkbox') {
            return;
          }

          onPhotoClick(photo.image);
        }}>
          <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 999 }}>
            <Checkbox
              checked={isPhotoSelected(photo.key)}
              style={{ color: colors.brand_3 }}
              onChange={() => selectPhoto(photo.key)}
            />
          </div>
          <GalleryPhoto
            source={photo.image}
            groupImageId={photo.group_image_id}
            handlePhotoDeleteRequest={handlePhotoDeleteRequest}
          />
        </GridListTile>
      ))}
    </GridList>
  );
};

GalleryGrid.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({
    child_group_image_id: PropTypes.number,
    group_image_id: PropTypes.number,
    child_id: PropTypes.number,
    created_at: PropTypes.string,
    image: PropTypes.string,
    key: PropTypes.string
  })),
  onPhotoClick: PropTypes.func,
  handlePhotoDeleteRequest: PropTypes.func,
  selectPhoto: PropTypes.func,
  isPhotoSelected: PropTypes.func // returns a bool
};

export default withWidth()(GalleryGrid);
